import React from 'react';
import { UserContext } from '../context/UserContext';
import HomeDashboard from './home/HomeDashboard';
import LandingPage from './landing/LandingPage';
import LoadingScreen from '../components/shared/loading/LoadingScreen';

/**
 * Conditional authentication based wrapper for '/' route of App
 * @returns {JSX.Element}
 */
const IndexView = () => {
  const { authenticated } = React.useContext(UserContext);
  return (
    <>
      {authenticated === null ? (
        <LoadingScreen />
      ) : authenticated ? (
        <HomeDashboard />
      ) : (
        <LandingPage />
      )}
    </>
  );
};

export default IndexView;
